import validate from "/codebuild/output/src2015616390/src/actions-runner/_work/onenews/onenews/web-services/node_modules/.pnpm/nuxt@3.16.2_@azure+identity@4.10.2_@azure+storage-blob@12.27.0_@parcel+watcher@2.4.1_@t_8115c2494d77b5551fa3da5112dab59f/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}